'use strict';

( function ( $ ) {
	$( '.course-content__item-title' ).on( 'click', function () {
		if (
			! $( this ).parents( '.course-content__item' ).hasClass( 'open' )
		) {
			$( '.course-content__item-title' )
				.parents( '.course-content__item' )
				.removeClass( 'open' );
			$( '.course-content__item-title' )
				.siblings( '.course-content__contents' )
				.slideUp();
		}
		$( this ).parents( '.course-content__item' ).toggleClass( 'open' );
		$( this ).siblings( '.course-content__contents' ).slideToggle();
	} );
} )( jQuery );
